import {
  convertDotcmsString,
  convertDotcmsResponseToRecord,
  extractAndSanitizeText,
} from './converters-from-dotcms';
import type { IGqlHelper } from './gql-helper';

/** This specifically does not have IBaseObjectData on it.
 * The GQL query will fail if you try to fetch that. */
export type IDotKeyValueData = {
  key: string;
  value: string;
};

export const DotKeyValueGqlHelper: IGqlHelper<IDotKeyValueData> = {
  contentTypeName: 'DotKeyValue',
  gqlFieldsQuery: `  
      key
      value
    `,
  processGqlData: (gqlResponse: unknown) => {
    if (!gqlResponse) {
      return undefined;
    }

    const { key, value } = convertDotcmsResponseToRecord(gqlResponse);

    return {
      key: convertDotcmsString(key) ?? '',
      value: extractAndSanitizeText(value) ?? '',
    };
  },
};
